import React, { useState, useEffect } from 'react';
import { List, Button, Icon, DatePicker, Input, Select } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons/faFileInvoice';
import { ContentCard } from '../../Common';
import { Text4, Text3 } from '../../../styles';
import moment from 'moment';
import { handleApiExceptions, printRupee, generate_query_set } from '../../../app_methods';
import { GstInvoice } from '../../../models';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../redux/actions';
import { PermissionHoc } from '../../HOC';
import { EaseModal } from '../../../libs/EaseModal';
import { SmartCollectGstInvoice } from '../../../models/smart_collect_invoice';
import { isEmpty } from "lodash";


const PermissableButton = PermissionHoc(Button,"INVOICES_DOWNLOAD",{ is_component: true, fallbackComponent: null })

const gstInvoice = new GstInvoice();

const InvoiceList = (props) => {
    const [invoices, setInvoices] = useState([]);
    const [pagination, setPagination] = useState({
        pageSize: 10,
        total: 0,
        current: 1,
        showTotal: (total) => `Total ${total} Records`
    });
    const [filters, setFilters] = useState({
        invoice_number: "",
        month: "",
        application:"wire"
    });
    const [isLoading, setIsLoading] = useState(false);
    const [downloadingId, setDownloadingId] = useState(false);
    const [showChargesModal, setShowChargesModal] = useState(false);

    const toggleChargesModal = () => {
        setShowChargesModal(!showChargesModal);
    };


    const fetchInvoices = async (_pagination, _filters = filters) => {
        if (!props.current_user.key) return;
        setIsLoading(true);
        const response = filters.application ==="insta_collect" ? 
        await SmartCollectGstInvoice.list({ pageSize: 10, current: _pagination.current, invoice_number: _filters.invoice_number, month: _filters.month ? _filters.month.format("YYYY-MM") : "" })
        :
        await GstInvoice.list({ pageSize: 10, current: _pagination.current, invoice_number: _filters.invoice_number, month: _filters.month ? _filters.month.format("YYYY-MM") : "" })
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        setInvoices(generate_query_set(filters.application ==="insta_collect" ? SmartCollectGstInvoice :GstInvoice, response.data.results));
        setPagination({ ..._pagination, total: response.data.count });
        setIsLoading(false);
    }
    
    const getInvoiceDescription = (invoice) => {
        return (
            <Text4>
                GST Invoice for the month <strong>{moment(invoice.month, "YYYY-MM").format("MMMM, YYYY")}</strong> · Net Amount: <strong>{printRupee(invoice.net_amount)}</strong>
            </Text4>
        )
    };

    const handlePagination = (page) => {
        let _pagination = pagination;
        pagination.current = page;
        setPagination(_pagination);
        fetchInvoices(_pagination);
    };

    const handleReset = () => {
        const _filters = { invoice_number: "", month: "" , application:""};
        fetchInvoices(pagination, _filters);
        setFilters(_filters);
    };

    const downloadInvoice = async (invoiceObj) => {
        setDownloadingId(invoiceObj.id);
        const response = await invoiceObj.download();
        if (!response.success) {
            setDownloadingId(undefined);
            handleApiExceptions(response);
            return;
        }
        setDownloadingId(undefined);
        window.open(response.data.url, '_blank');}

    const renderFilters = () => {
        return (
            <div className="align-items-center justify-content-end mb-4 clearfix">
                {/* <Button type="link" className="p-0 m-0" onClick={toggleChargesModal}>Click Here</Button> to see applied charges. */}
                <div style={{float: "right"}}>
                <Text4 className="mr-1" strong>Invoice No.:</Text4>
                <Input
                    autoComplete='off'
                    style={{ width: "200px" }}
                    className="mr-2"
                    size="small"
                    placeholder="Input Invoice No."
                    value={filters.invoice_number}
                    onChange={e => setFilters({ ...filters, invoice_number: e.target.value })}
                    onPressEnter={() => fetchInvoices(pagination)}
                />
                <Text4 className="mr-1" strong>Month:</Text4>
                <DatePicker.MonthPicker
                    className="mr-2"
                    size="small"
                    placeholder="Select month"
                    disabledDate={(date) => date.valueOf() > moment().valueOf()}
                    value={filters.month}
                    format="MMMM, YYYY"
                    onChange={value => { fetchInvoices(pagination, { ...filters, month: value }); setFilters({ ...filters, month: value }); }}
                />
                {
                   !isEmpty(props.current_user?.smart_collect_virtual_account || {}) ?
                <>
                <Text4 className="mr-1" strong>Platform:</Text4>
                <Select className="mr-2" defaultValue="wire"
                    size="small"
                    placeholder="Enter platform" style={{ width: "200px" }}  onChange={value => setFilters({ ...filters, application:value })}
                    onPressEnter={() => fetchInvoices(pagination)} >
                    <Select.Option value="wire">Wire</Select.Option>
                    <Select.Option value="insta_collect">InstaCollect</Select.Option>
                </Select>
                <Button className="mr-1" size="small" type="primary" onClick={() => fetchInvoices(pagination)}><Icon type="search" /></Button>
                </>:null
            }
                </div>
            </div>
        )
    };

    const renderList = () => {
        return (
            <List
                loading={isLoading}
                dataSource={invoices}
                renderItem={item => (
                    <List.Item
                        className="c-pointer "
                        key={item.id}
                        extra={
                            item.net_amount > 0 ?
                                <PermissableButton  disabled={!(item.is_downloadable)} loading={downloadingId === item.id} icon="download" onClick={() => downloadInvoice(item)}> Download Invoice </PermissableButton>
                                :null
                        }
                    >
                        <List.Item.Meta
                            avatar={<FontAwesomeIcon color="#d63b41" icon={faFileInvoice} style={{ fontSize: 20 }} />}
                            title={<Text3>Invoice No.: <strong>{item.net_amount == 0 ? "NA" : item.invoice_number}</strong></Text3>}
                            description={getInvoiceDescription(item)}
                        />
                    </List.Item>
                )}
                pagination={{
                    onChange: page => handlePagination(page),
                    ...pagination
                }}
            >
            </List>
        )
    };

    useEffect(() => {
        props.onChildMount();
        fetchInvoices(pagination);
    }, []);

    return (
        <ContentCard className="p-3">
            {renderFilters()}
            {renderList()}
            {/* <EaseModal
            width={850}
            title={false}
            visible={showChargesModal}
            onCancel={toggleChargesModal}
            centered
            hideFooter
            destroyOnClose
            >
                <div className="font-weight-bold mb-3" style={{fontSize: "18px"}}>Platform Charges</div>
                <div className="row pt-2 pb-2 ml-3 mr-3" style={{background: "rgba(0, 0, 0, 0.05)", fontWeight: "bold"}}>
                <div className="col-3"><Text3>IMPS</Text3></div>
                <div className="col-3"><Text3>NEFT</Text3></div>
                <div className="col-3"><Text3>RTGS</Text3></div>
                <div className="col-3"><Text3>UPI</Text3></div>
                </div>
                <div className="row pt-2 pb-2 ml-3 mr-3" style={{display: "flex", alignItems: "center"}}>
                <div className="col-3">
                {
                props.current_user.service_charges.IMPS.map(chrg => {
                    return (
                    <Text3>{chrg.min_txn_amount || chrg.min_txn_amount == 0?"₹"+chrg.min_txn_amount:""}{chrg.max_txn_amount?" to ₹"+chrg.max_txn_amount+" - ":chrg.min_txn_amount?" and above - ":""}{chrg.charge}{chrg.charge_in_percent?"%":"₹"} <br /></Text3>
                   )
                })
                }
                </div>
                <div className="col-3">
                {
                props.current_user.service_charges.NEFT.map(chrg => {
                    return (
                    <Text3>{chrg.min_txn_amount || chrg.min_txn_amount == 0?"₹"+chrg.min_txn_amount:""}{chrg.max_txn_amount?" to ₹"+chrg.max_txn_amount+" - ":chrg.min_txn_amount?" and above - ":""}{chrg.charge}{chrg.charge_in_percent?"%":"₹"} <br /></Text3>
                   )
                })
                }
                </div>
                <div className="col-3">
                {
                props.current_user.service_charges.RTGS.map(chrg => {
                    return (
                    <Text3>{chrg.min_txn_amount || chrg.min_txn_amount == 0?"₹"+chrg.min_txn_amount:""}{chrg.max_txn_amount?" to ₹"+chrg.max_txn_amount+" - ":chrg.min_txn_amount?" and above - ":""}{chrg.charge}{chrg.charge_in_percent?"%":"₹"} <br /></Text3>
                   )
                })
                }
                </div>
                <div className="col-3">
                {
                props.current_user.service_charges.UPI.map(chrg => {
                    return (
                    <Text3>{chrg.min_txn_amount || chrg.min_txn_amount == 0?"₹"+chrg.min_txn_amount:""}{chrg.max_txn_amount?" to ₹"+chrg.max_txn_amount+" - ":chrg.min_txn_amount?" and above - ":""}{chrg.charge}{chrg.charge_in_percent?"%":"₹"} <br /></Text3>
                   )
                })
                }
                </div>
                </div>
            </EaseModal> */}

        </ContentCard>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(InvoiceList, 'INVOICES_READ'));